import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Terms } from 'components';
import { LoggedOutLayout } from 'containers';

var TermsAndConditions = /*#__PURE__*/function (_Component) {
  _inherits(TermsAndConditions, _Component);

  var _super = _createSuper(TermsAndConditions);

  function TermsAndConditions() {
    _classCallCheck(this, TermsAndConditions);

    return _super.apply(this, arguments);
  }

  _createClass(TermsAndConditions, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LoggedOutLayout, {
        showNavBar: true
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Terms And Conditions"
      }), /*#__PURE__*/React.createElement(Terms, null));
    }
  }]);

  return TermsAndConditions;
}(Component);

export { TermsAndConditions as default };